import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MUIFormHelperText from '@material-ui/core/FormHelperText';
import MUIFormControl from '@material-ui/core/FormControl';
import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import MUISelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core';
import FormContext from '../FormContext';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.grey[50],
    '&.Mui-disabled': {
      background: theme.palette.grey[50]
    }
  }
}));

const UnitTextField = ({
  label,
  dataField,
  helperText,
  disabled = false,
  injectAction,
  units
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  const value = getFieldValue(dataField);
  const datas = dataField.split('.');
  const findOriginalData = datas[datas.length - 1];
  const selectedUnit = getFieldValue(`${findOriginalData}Unit`);
  let unit = selectedUnit || units[0].code;

  function getLabel() {
    return label ? formatMessage({ id: label }) : label;
  }

  function getHelperText() {
    return helperText ? formatMessage({ id: helperText }) : helperText;
  }

  return (
    <MUIFormControl variant="filled" margin="normal" fullWidth>
      <InputLabel>{getLabel()}</InputLabel>
      <FilledInput
        classes={classes}
        disabled={disabled}
        value={value}
        onChange={event => {
          setFieldValue(dataField, event.target.value);
        }}
        endAdornment={
          <InputAdornment position="end">
            <MUISelect
              disabled={disabled}
              value={unit}
              onChange={event => {
                if (injectAction) {
                  injectAction(event.target.value);
                }
                setFieldValue(`${findOriginalData}Unit`, event.target.value);
              }}
              disableUnderline
            >
              {units.map(item => {
                return (
                  <MenuItem key={`select-item/${item.code}`} value={item.code}>
                    {item.text}
                  </MenuItem>
                );
              })}
            </MUISelect>
          </InputAdornment>
        }
      />
      <MUIFormHelperText>{getHelperText()}</MUIFormHelperText>
    </MUIFormControl>
  );
};

UnitTextField.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  disabled: PropTypes.bool
};

export default UnitTextField;
